export default class ControlMessage {
  constructor(s, t) {
    (this.triggerId = s),
      (this.messageExtras = t),
      (this.triggerId = s),
      (this.messageExtras = t),
      (this.extras = {}),
      (this.isControl = !0),
      (this.Ht = !1);
  }
  static fromJson(s) {
    return new ControlMessage(s.trigger_id, s.message_extras);
  }
  _t() {
    return !this.Ht && ((this.Ht = !0), !0);
  }
  Bo() {
    return this.Ht;
  }
}
